/** Catalog codes (sizes, option values, categories, sports): 1–6 of A–Z 0–9, stored uppercase. */
export const CATALOG_CODE_MAX = 6;
/** Product codes: up to 32 of A–Z 0–9 and "-". */
export const PRODUCT_CODE_MAX = 32;
/** SKUs: up to 64 of A–Z 0–9 and "-". */
export const SKU_MAX = 64;
export const CODE_RULE = "1–6 letters or digits";

/** What a catalog-code field keeps of the typed text: uppercase letters and digits, at most `max`. */
export const normalizeCode = (input: string, max = CATALOG_CODE_MAX) =>
  input.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, max);

/** Product codes and SKUs keep "-" too. */
export const normalizeSkuCode = (input: string, max: number) => input.toUpperCase().replace(/[^A-Z0-9-]/g, "").slice(0, max);

/** A code suggested from a name: its first 6 letters/digits ("T-shirts" → "TSHIRT"), the migration's rule. */
export const codeFromName = (name: string) => normalizeCode(name);

export const isCatalogCode = (code: string) => /^[A-Z0-9]{1,6}$/.test(code);

export const isSkuCode = (code: string, max: number) => code.length > 0 && code.length <= max && /^[A-Z0-9-]+$/.test(code);
